import React from "react";
import { compose, withProps } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";

//const demoFancyMapStyles = require("./mapStyles.json");

const MyMapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GOOGLE_MAP_KEY}`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `150px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)((props) =>
  <GoogleMap
    defaultZoom={12}
    defaultCenter={{ lat: props.lat, lng: props.lng }}
    defaultOptions={{
      //styles: demoFancyMapStyles
      disableDefaultUI: true,
    }}
  >
    {props.isMarkerShown && <Marker
      position={{ lat: props.lat, lng: props.lng }}
      icon={process.env.GATSBY_MAP_MARKER.replace("/upload/", "/upload/w_20/")}
    />}
  </GoogleMap>
)

class MapComponent extends React.PureComponent {
  state = {
    isMarkerShown: true,
  }

  componentDidMount() {
    this.delayedShowMarker()
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true })
    }, 3000)
  }

  render() {
    return (

      <MyMapComponent
        isMarkerShown={this.state.isMarkerShown}
        lat={this.props.lat}
        lng={this.props.lng}
      />

    )
  }
}

export default MapComponent